export const pageWrapper = document.documentElement;
export const isOldBackoffice = !!pageWrapper;
export const scrollSource = window;

export class T {
    public static _(message: string, domain: string): string {
        const wnd = window as any;
        return wnd.T2 ? wnd.T2._(message, domain) : message;
    }
}

export function getScroll(scrollElement: HTMLElement = pageWrapper) {
    const left = scrollElement.scrollLeft - (scrollElement.clientLeft || 0);
    const top = scrollElement.scrollTop - (scrollElement.clientTop || 0);
    const scrollHeight = scrollElement.scrollHeight;
    const totalHeight = scrollElement.clientHeight;
    const isAtEnd = top > scrollHeight - totalHeight - 10;

    return { top, left, scrollHeight, totalHeight, isAtEnd };
}

export function isMobile() {
    return window.innerWidth < 768;
}
/* 
Return if an hex color is near white or black
@param color - hex color
@return 1 if near white, 0 if near black, -1 if neither
*/
export function isNearWhiteOrBlack(color: string): number {
    const [R, G, B] = color.match(/\w\w/g)!.map((x) => parseInt(x, 16));
    const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    if (luminance > 140) {
        return 1;
    } else if (luminance < 80) {
        return 0;
    }
    return -1;
}

export const hoverOpacity = () => `
  transition: opacity ease 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export type ReactType<T> = React.DetailedHTMLProps<React.InputHTMLAttributes<T>, T>;
